import Phaser from "phaser";
import * as config from './config';
import helper from './helpers'

const app = document.getElementById('app');
app.style.cssText = `width: 100%; height: 100%; margin: auto`;

export function boot() {
    return new Phaser.Game(config);
}

boot();
